import { useState } from 'react'
import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { MessageConditionFilter } from '../../components/MessageConditionFilter'
import { MessageForm } from '../../components/MessageForm'
import { GetPlayerByConditionRequest } from '../../types'

const CreateMessagePage = () => {
	const [phoneNumbers, setPhoneNumbers] = useState<string[]>([])
	const [lineIds, setLineIds] = useState<string[]>([])
	const [playerCondition, setPlayerCondition] =
		useState<GetPlayerByConditionRequest | null>(null)

	const handlePlayersQueried = (
		phones: string[],
		lines: string[],
		condition: GetPlayerByConditionRequest,
	) => {
		setPhoneNumbers(phones)
		setLineIds(lines)
		setPlayerCondition(condition)
	}

	const handleSendSuccess = () => {
		// Reset all state after successful send
		setPhoneNumbers([])
		setLineIds([])
		setPlayerCondition(null)
	}

	return (
		<PageContainer>
			<div className="space-y-6">
				<div>
					<h1 className="text-3xl font-bold">ส่งข้อความ</h1>
					<p className="mt-2 text-muted-foreground">
						ส่งข้อความให้กับสมาชิกผ่าน SMS, LINE หรือหลายช่องทาง
					</p>
				</div>

				<div className="grid gap-6 md:grid-cols-2">
					<MessageConditionFilter onPlayersQueried={handlePlayersQueried} />
					<MessageForm
						phoneNumbers={phoneNumbers}
						lineIds={lineIds}
						playerCondition={playerCondition}
						onSendSuccess={handleSendSuccess}
					/>
				</div>
			</div>
		</PageContainer>
	)
}

const GuardedCreateMessagePage = withUserPermission(CreateMessagePage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_SMS],
})

export { GuardedCreateMessagePage as CreateMessagePage }
